var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.796387,
    y: 1.09375,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#C44744",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.796387,
    y: 1.09375,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#C44744"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1714 14.3438H24.0464V13.7188C24.0464 13.2215 23.8488 12.7446 23.4972 12.3929C23.1456 12.0413 22.6687 11.8438 22.1714 11.8438H18.4214C17.9241 11.8438 17.4472 12.0413 17.0956 12.3929C16.7439 12.7446 16.5464 13.2215 16.5464 13.7188V14.3438H13.4214C13.2556 14.3438 13.0967 14.4096 12.9794 14.5268C12.8622 14.644 12.7964 14.803 12.7964 14.9688C12.7964 15.1345 12.8622 15.2935 12.9794 15.4107C13.0967 15.5279 13.2556 15.5938 13.4214 15.5938H14.0464V26.8438C14.0464 27.1753 14.1781 27.4932 14.4125 27.7276C14.6469 27.9621 14.9649 28.0938 15.2964 28.0938H25.2964C25.6279 28.0938 25.9458 27.9621 26.1803 27.7276C26.4147 27.4932 26.5464 27.1753 26.5464 26.8438V15.5938H27.1714C27.3371 15.5938 27.4961 15.5279 27.6133 15.4107C27.7305 15.2935 27.7964 15.1345 27.7964 14.9688C27.7964 14.803 27.7305 14.644 27.6133 14.5268C27.4961 14.4096 27.3371 14.3438 27.1714 14.3438ZM17.7964 13.7188C17.7964 13.553 17.8622 13.394 17.9794 13.2768C18.0967 13.1596 18.2556 13.0938 18.4214 13.0938H22.1714C22.3371 13.0938 22.4961 13.1596 22.6133 13.2768C22.7305 13.394 22.7964 13.553 22.7964 13.7188V14.3438H17.7964V13.7188ZM25.2964 26.8438H15.2964V15.5938H25.2964V26.8438ZM19.0464 18.7188V23.7188C19.0464 23.8845 18.9805 24.0435 18.8633 24.1607C18.7461 24.2779 18.5871 24.3438 18.4214 24.3438C18.2556 24.3438 18.0967 24.2779 17.9794 24.1607C17.8622 24.0435 17.7964 23.8845 17.7964 23.7188V18.7188C17.7964 18.553 17.8622 18.394 17.9794 18.2768C18.0967 18.1596 18.2556 18.0938 18.4214 18.0938C18.5871 18.0938 18.7461 18.1596 18.8633 18.2768C18.9805 18.394 19.0464 18.553 19.0464 18.7188ZM22.7964 18.7188V23.7188C22.7964 23.8845 22.7305 24.0435 22.6133 24.1607C22.4961 24.2779 22.3371 24.3438 22.1714 24.3438C22.0056 24.3438 21.8467 24.2779 21.7294 24.1607C21.6122 24.0435 21.5464 23.8845 21.5464 23.7188V18.7188C21.5464 18.553 21.6122 18.394 21.7294 18.2768C21.8467 18.1596 22.0056 18.0938 22.1714 18.0938C22.3371 18.0938 22.4961 18.1596 22.6133 18.2768C22.7305 18.394 22.7964 18.553 22.7964 18.7188Z",
    fill: "#C44744",
    stroke: "#C44744",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a9f0f4cd9558aac46f58cade2140515f.svg";
export { ForwardRef as ReactComponent };